// Game Designer Kit — build instructions.
// The Parts Checklist lives on its own page (/checklist).
// The 8 assembly steps below are shown inside the volunteer build flow.
// Text is taken verbatim from the "Steps In build instruction page" sheet.

const videoMp4 = (n) => `/videos/step-${n}.mp4`;
const videoWebm = (n) => `/videos/step-${n}.webm`;

export const projectMeta = {
  name: "Game Designer Kit",
  greeting: "Hi There!",
  headline: "These are the steps you have to follow today!",
  subline: (n) => `There are ${n} steps in total.`,
  prompt: "Choose how you want to proceed:",
};

// Total pages in the picture guide (parts checklist + 8 build steps).
export const TOTAL_STEPS = 9;

// The 8 build steps (numbered 1..8 to match the printed instruction sheet).
// `videoStart` is the timestamp (seconds) inside the master build video at /videos/gdk-base.mp4.
export const steps = [
  {
    no: 1,
    title: "Pull the paper tab out of the battery holder.",
    substeps: [
      "Pull the paper tab out of the holder in the direction of the arrow.",
      "Close the battery case.",
    ],
    note: "The battery is already in the holder. Do not remove the battery.",
    video: videoMp4(1),
    videoWebm: videoWebm(1),
    videoStart: 0,
  },
  {
    no: 2,
    title: "Insert the hex spacers at all 4 corners.",
    substeps: [
      "At each of the 4 corners, insert a large hex spacer from the back and a small hex spacer from the front.",
      "Screw them in place.",
    ],
    video: videoMp4(2),
    videoWebm: videoWebm(2),
    videoStart: 5.6,
  },
  {
    no: 3,
    title: "Attach the button sleeves.",
    substeps: [
      "Attach the 4 yellow button sleeves to the up, down, left, and right slots.",
      "Attach the 3 red button sleeves to the Menu, A, and B slots.",
    ],
    video: videoMp4(3),
    videoWebm: videoWebm(3),
    videoStart: 7.6,
  },
  {
    no: 4,
    title: "Attach the top panel.",
    substeps: [
      "Place the top panel so the screen hole and button cut-outs line up.",
      "Screw it down with the small screws.",
    ],
    video: videoMp4(4),
    videoWebm: videoWebm(4),
    videoStart: 9.6,
  },
  {
    no: 5,
    title: "Attach the bottom panel.",
    substeps: [
      "Place the bottom panel with the \"g\" facing you.",
      "Screw it down with the small screws.",
    ],
    video: videoMp4(5),
    videoWebm: videoWebm(5),
    videoStart: 11.6,
  },
  {
    no: 6,
    title: "Attach the holder tag.",
    substeps: [
      "Attach the holder tag to the corner hole as shown.",
    ],
    video: videoMp4(6),
    videoWebm: videoWebm(6),
    videoStart: 13.6,
  },
  {
    no: 7,
    title: "Insert the micro:bit.",
    substeps: [
      "Insert the micro:bit into its slot.",
      "Make sure the LED switch is on before powering up.",
    ],
    note: "The LEDs of the micro:bit should be on the same side as the LED screen.",
    video: videoMp4(7),
    videoWebm: videoWebm(7),
    videoStart: 16.8,
  },
  {
    no: 8,
    title: "Your game designer kit is ready to be programmed!",
    substeps: [
      "Great work! Head over to the Testing screen to flash your first game onto the micro:bit.",
    ],
    gif: "/gifs/step-8.gif",
  },
];

export function getStepByNo(no) {
  return steps.find((s) => s.no === no);
}
